"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XMappingMappedBy = exports.XMappingState = exports.XMappingReviewState = void 0;
const values_1 = require("@busbud/int-schemas/udm/values");
Object.defineProperty(exports, "XMappingMappedBy", { enumerable: true, get: function () { return values_1.StopMappedBy; } });
var XMappingReviewState;
(function (XMappingReviewState) {
    XMappingReviewState["Good"] = "good";
    XMappingReviewState["Bad"] = "bad";
    XMappingReviewState["None"] = "none";
})(XMappingReviewState = exports.XMappingReviewState || (exports.XMappingReviewState = {}));
var XMappingState;
(function (XMappingState) {
    XMappingState["Active"] = "active";
    XMappingState["Disabled"] = "disabled";
})(XMappingState = exports.XMappingState || (exports.XMappingState = {}));
//# sourceMappingURL=xmappings.js.map